<h1 class="table__title">Search Filter</h1>
<ul class="table__control inline-list">
  <li>
    <button mat-raised-button color="accent" (click)="reset()">Reset</button>
  </li>
  <li>
    <button [disabled]="disabled" mat-raised-button color="primary" (click)="searchNow(value)">Search</button>
  </li>
  <li>
    <button mat-raised-button (click)="addField()">
      <mat-icon><img src="assets/images/icon-add.svg" /></mat-icon>
      Add Field
    </button>
  </li>
</ul>

<ng-form id="searchForm" #searchForm="ngForm" novalidate>
  <!-- {{searchForm.errors | json}} {{searchForm.valid}} -->

  <div class="fuzzySearch">
    <div class="form-container">
      <mat-form-field appearance="outline">
        <mat-label>Search for Contract</mat-label>
        <input #textFilter="ngModel" matInput name="textFilter" [(ngModel)]="value.textFilter"
          pattern="^[^\'\+\-\*\?\&quot;]+$" />
        <mat-error>Special characters and punctuation are not supported
        </mat-error>
      </mat-form-field>
    </div>
    <div class="form-container">
      <!-- Tired of fighting with this so just a hack -->
      <mat-checkbox class="custom-check-box" name="excactMatch" [checked]="value.exactMatch"
        [(ngModel)]="value.exactMatch">Exact Match
      </mat-checkbox>
    </div>
  </div>

  <ng-container *ngFor="let key of valueKeys()">
    <app-search-field *ngIf="key" #keyField="ngModel" [searchField]="key" [availableKeys]="availableKeys()"
      [objectStore]="objectStore" [name]="key" [(ngModel)]="value[key.id]" (typeChanged)="typeChanged(key,$event)"
      (fieldDeleted)="fieldDeleted($event)">
    </app-search-field>

    <!-- Valid: {{keyField?.valid | json}} - > {{keyField?.errors | json}} -->
  </ng-container>

</ng-form>



<!-- {{value | json}}
<hr>
{{availableKeys() | json}} -->
